import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function StatusWarning({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
    >
      <Path
        d="M1.82331 14.0008H14.1766C14.69 14.0008 15.01 13.4475 14.7566 13.0008L8.57664 2.33415C8.31664 1.88748 7.67664 1.88748 7.42331 2.33415L1.24331 13.0008C0.989972 13.4475 1.30997 14.0008 1.82331 14.0008ZM8.66997 12.0008H7.33664V10.6675H8.66997V12.0008ZM8.00331 9.33415C7.63664 9.33415 7.33664 9.03415 7.33664 8.66748V7.33415C7.33664 6.96748 7.63664 6.66748 8.00331 6.66748C8.36997 6.66748 8.66997 6.96748 8.66997 7.33415V8.66748C8.66997 9.03415 8.36997 9.33415 8.00331 9.33415Z"
        fill={iconColor}
      />
    </Svg>
  );
}
